import { clone } from 'lodash'
import { EmptyStateProps as ToqioEmptyStateProps, SIZE, WEIGHT } from '@toqio/toqio-web-components';

export const TITLE_SIZE = clone(SIZE);
export const TITLE_WEIGHT = clone(WEIGHT);

export interface PlaceholderProps extends ToqioEmptyStateProps {
  /**
   * Boolean to show or hide the component
   */
  visible: boolean;
  /**
   * Classname for the container wrapping the component
   */
  containerClassName?: string;
  /**
   * Children to render in the container, below the component
   */
  children?: React.ReactNode;
}